<template>
    <div>
        超时
    </div>
</template>

<script>
    export default {
        name: "timeout"
    }
</script>

<style scoped>

</style>